import axios from "axios";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import addLogDocument from "../addLogDocument"; // Custom log function
import { auth, dbCentral } from "../../config/FirebaseConfig";

const addCarnetDocument = async (
  file,
  carnet_id = "",
  document_type = "",
  token,
  prefix
) => {
  try {
    const fileUrl = file.url;

    // Download the file from the provided URL using Axios
    const fileResponse = await axios.get(fileUrl, {
      responseType: "arraybuffer",
    });

    if (fileResponse.status === 200) {
      // Convert the response to Uint8Array to ensure binary data integrity
      const fileBytes = new Uint8Array(fileResponse.data);
      const fileName =
        extractName(file.name) + "." + extractExtension(file.name);

      const url = `${prefix}carnets/${carnet_id}/documents/${document_type}`;

      // Prepare the FormData with explicit MIME type for PDF
      const formData = new FormData();
      formData.append(
        "file",
        new Blob([fileBytes], { type: "application/pdf" }),
        fileName
      );

      // Define headers, letting Axios handle the multipart Content-Type
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let start = new Date();

      // Upload the file using Axios
      const response = await axios.post(url, formData, { headers });
      // i want JSON response
      const responseText = await response.data;
      const uploadedFile = responseText.file;
      // Firebase authentication to get current user
      const currentUser = auth.currentUser;

      if (!currentUser) {
        console.error("User is not authenticated");
        return;
      }

      // Access Firestore to retrieve the user document
      const userRef = doc(dbCentral, "user", currentUser.uid);
      const userSnapshot = await getDoc(userRef);

      if (!userSnapshot.exists()) {
        console.error("User document not found");
        return;
      }
      const orgId = userSnapshot.get("org_id");

      let end = new Date();
      let elapsed = end - start;
      // Log the document upload
      await addLogDocument(
        url,
        prefix,
        userRef.id,
        orgId,
        response.status.toString(),
        carnet_id,
        "", // Assuming empty for additional data
        "", // Assuming no specific request body
        responseText,
        "POST",
        elapsed
      );

      if (response.status === 200) {
        return;
      } else {
        console.error(
          `Error response for file ${fileName}: ${response.status}`
        );
      }
    } else {
      console.error(`Failed to download file from URL: ${fileResponse.status}`);
    }
  } catch (error) {
    console.error("Error processing files:", error);
  }
};

export default addCarnetDocument;

export const extractExtension = (filename) => {
  const parts = filename.split(".");
  return parts.length > 1 ? parts.pop() : "";
};
export const extractName = (filename) => {
  const parts = filename.split(".");
  return parts.length > 1 ? parts.slice(0, -1).join(".") : filename;
};
